export function setLoading(state, loading) {
    state.loading = loading;
}

export function setDocument(state, document) {
    state.document = document;
}

export function setError(state, error) {
    state.error = error;
}

export function setShowModal(state, show) {
    state.showModal = show;
}



// WEBPACK FOOTER //
// ./src/modules/public-invoice/mutations.js